import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { TextBody } from 'web-ui-components/lib/atoms/text';
import paymentDetailContent, { contentPropTypes } from './paymentDetailsHeader.content';
import withContent from '../../../../containers/withContent';

export const PaymentDetailsHeader = ({
	isEditing,
	content: { header, headerEdit, description, ideaHowMuchPaymentWillCost },
}) => (
	<div>
		<PageHeading data-test-id="payment-details">{isEditing ? headerEdit : header}</PageHeading>
		<TextBody>{description}</TextBody>
		<TextBody>{ideaHowMuchPaymentWillCost}</TextBody>
	</div>
);

PaymentDetailsHeader.propTypes = {
	content: PropTypes.shape(contentPropTypes),
	isEditing: PropTypes.bool,
};
export default compose(withContent({ content: paymentDetailContent }))(PaymentDetailsHeader);
